module.exports = __webpack_public_path__ + "static/media/2.b4979bf0.jpg";